<script lang="ts">
	import type { FragmentOf } from '$lib/graphql';
	import { path } from '$lib/translations';
	import { ƒ_photograph } from '$lib/routes';
	import { yearMonthDaySlug } from '$lib/domain/photograph';

	import { PhotographPermalinkFragment } from './PhotographPermalink.fragment';

	import type { HTMLAnchorAttributes } from 'svelte/elements';

	let { photograph, children, ...rest }: { photograph: FragmentOf<typeof PhotographPermalinkFragment> } & HTMLAnchorAttributes = $props();
</script>

<a {...rest} href={$path(ƒ_photograph, yearMonthDaySlug(photograph))}>{@render children?.()}</a>
